import CircularProgress from "@material-ui/core/CircularProgress";
import { usePdf } from "@mikecousins/react-pdf";
import styled from "@material-ui/core/styles/styled";
import pxToRem from "libs/pxToRem";
import React, { useRef } from "react";

interface IPDFViewer {
  url: string;
}

interface IPDFPageProps {
  url: string;
  pageNumber: number;
}

const PDFPage = ({ url, pageNumber }: IPDFPageProps) => {
  const canvasRef = useRef(null);
  usePdf({
    file: url,
    page: pageNumber,
    canvasRef,
  });

  return <StyledCanvas ref={canvasRef} />;
};

const PDFViewer = ({ url }: IPDFViewer) => {
  const canvasRef = useRef(null);
  const { pdfDocument } = usePdf({
    file: url,
    canvasRef,
  });

  if (!pdfDocument) {
    return (
      <div>
        <CircularProgress style={{ margin: 100 }} />
      </div>
    );
  }

  const totalPages = pdfDocument.numPages;
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <PagesContainer>
      {pages.map((pageNumber) => (
        <PDFPage key={pageNumber} url={url} pageNumber={pageNumber} />
      ))}
    </PagesContainer>
  );
};

export default PDFViewer;

const PagesContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(20),
  alignItems: "center",
});

const StyledCanvas = styled("canvas")({
  width: pxToRem(743),
  height: pxToRem(1052),
});
